import { IDispatcherService, IDispatcher, IHistorianStorageConfigurationActionsService } from '../';
import { HistorianStorageConfiguration } from '../../models';

export interface IHistorianStorageConfigurationStoreService {
    getAll(): angular.IPromise<HistorianStorageConfiguration[]>;
    getAll(force: boolean): angular.IPromise<HistorianStorageConfiguration[]>;
    updateMany(targets: HistorianStorageConfiguration[]): angular.IPromise<HistorianStorageConfiguration[]>;
    deleteMany(guids: string[]): angular.IPromise<HistorianStorageConfiguration[]>;
}

export interface IHistorianStorageConfigurationActionsDispatcherService extends IDispatcherService<IHistorianStorageConfigurationStoreService> { }

export class HistorianStorageConfigurationActionsDispatcherService implements IHistorianStorageConfigurationActionsDispatcherService {
    static serviceId = 'historianStorageConfigurationActionsDispatcherService';

    static $inject = ['historianStorageConfigurationActionsService'];

    constructor(private _actionService: IHistorianStorageConfigurationActionsService) { }

    getDispatcher(dispatch: Function): IDispatcher<IHistorianStorageConfigurationStoreService> {
        const actionService = this._actionService;

        return {
            dispatcher: {
                getAll: (force?: boolean) => dispatch(actionService.getAll(force)),
                updateMany: (targets: HistorianStorageConfiguration[]) => dispatch(actionService.updateMany(targets)),
                deleteMany: (guids: string[]) => dispatch(actionService.deleteMany(guids))
            }
        };
    }
}